import { Embeddings } from "../../features/Embeddings";

export const EmbeddingsPage = () => {
  return (
    <Embeddings/>
  );
};
